import { createMuiTheme } from '@material-ui/core';

import palette from './palette';
// import typography from './typography';
import overrides from './overrides';

const theme = createMuiTheme({
  palette,
  // typography,
  overrides,
  zIndex: {
    appBar: 1200,
    drawer: 1100,
  },
  paper: {
    radius: 10,
  },
  typography: {
    fontFamily: "'Lato', sans-serif",
    fontSize: 14,
    color: '#4a494b',
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
  },
  dtPaper: {
    borderRadius: 10,
  },
});

export default theme;
